angular.module('charts')
  .controller('StandardsGridTableController', [
    '$scope',
    '$filter',
    'customer',
    'standard',
    '$timeout',
    '$state',
    '$modal',
    'assignMode',
    '$rootScope',
    'moment',
    'configuration',
    'navigation',
    'edxDateTimeService', function(
      $scope,
      $filter,
      $customer,
      $standard,
      $timeout,
      $state,
      $modal,
      $assignMode,
      $rootScope,
      $moment,
      dblConfiguration,
      navigation,
      dateTimeService) {
    $scope.customerStandard = $customer.getAcademicStandard();
    $scope.sort = {};
    $scope.isNeedsAttentionEnabled = dblConfiguration.isFeatureEnabled('standards_grid_needs_attention_enabled');
    $scope.someStandardHaveNewLessons = false;

    $scope.customProficiency = {
        'dbl': 'dbl',
        'uk_standards_2013': 'uk'
      }[$customer.getAcademicStandard().academic_standard_name];
    $scope.useShortDescription = !!$scope.customProficiency;

    $scope.allowAssignments = $assignMode.assignmentsAllowed() && !dblConfiguration.isFeatureEnabled('dbl_lite');
    $scope.$watch("gridData.standards", function() {
      $scope.sort = {activeColumnIndex: -1, order: 'asc'};

      // calculate standard name length so can add extra header height if needed
      var maxLength = 0;
      _.each($scope.gridData.standards, function (standard) {
        // since dots and ones take less space, count them less
        var numberOfDots = (standard.name.match(/\./g) || []).length;
        var numberOfOnes = (standard.name.match(/1/g) || []).length;
        var approxLength = standard.name.length - 0.67 * numberOfDots - 0.33 * numberOfOnes;

        if (approxLength > maxLength) {
          maxLength = approxLength;
        }
      });

      if ($scope.gridData.standards) {
        $scope.someStandardHaveNewLessons = $scope.gridData.standards.some(function (standard) {
          return standard.has_new_lessons;
        });
      }

      $scope.tallHeader = maxLength > 6;
    });

    $scope.getProficiencyDate = function() {
      if ($rootScope.reportDates) {
        return $moment($rootScope.reportDates.to_date).format('LL');
      }
      return "";
    };

    $scope.getProficiencyDateDayOfTheWeek = function() {
      if ($rootScope.reportDates) {
        return dateTimeService.dayOfWeekOrToday($rootScope.reportDates.to_date);
      }
      return "";
    };

    $scope.getDomainStyle = function(domain) {
      var resultStyle = "";
      if ($scope.sort.activeColumnIndex >= 0 && $scope.sort.activeColumnIndex < $scope.gridData.standards.length) {
        var standard = $scope.gridData.standards[$scope.sort.activeColumnIndex];
        var selectedDomain = standard.domain;
        if (domain === selectedDomain) {
          resultStyle = "active-box ";
        }
      }
      return resultStyle + "first-standard";
    };

    $scope.getBorderStyle = function(index) {
      if (index < 0 || index >= $scope.gridData.standards.length) {
        return "";
      }
      var standard = $scope.gridData.standards[index];
      var domain = standard.domain;
      if (standard === domain.standards[0]) {
        return " first-standard";
      }
      return " ";
    };

    $scope.getColumnStyle = function(index) {
      var activeStyle = $scope.sort.activeColumnIndex === index ? "active-box " + ($scope.sort.order === 'asc' ? 'ascending' : 'descending') : "inactive-box";

      if ($scope.useShortDescription) {
        activeStyle += ' standard-header-short-description';
      } else {
        activeStyle += $scope.tallHeader ? ' standard-header-tall' : '';
      }

      return activeStyle + $scope.getBorderStyle(index);
    };

    $scope.getCellStyle = function(index) {
      var activeStyle = $scope.sort.activeColumnIndex === index ? "active-box" : "inactive-box";

      return activeStyle + $scope.getBorderStyle(index);
    };

    $scope.onStandardClicked = function(standardIndex) {
      sortByStandard(standardIndex);
    };

    $scope.onStudentsHeaderClicked = function() {
      sortByStudentsName();
    };

    $scope.openModal = function(domain) {
      $scope.modal = $modal.open({
        templateUrl: 'resources/core/partials/domain-standard-modal.html',
        windowClass: 'domain-standard-modal',
        controller: 'DomainStandardModalController',
        backdrop: false,
        keyboard: true,
        resolve: {
          domain: function () {
            return domain;
          },
          grade: function() {
            return $scope.gridData.grade;
          },
          selectedStandard: function () {}
        }
      });

      $scope.modal.result.then(function (standardDescriptor) {
        if (!standardDescriptor) {
          return;
        }

        $standard.resetQueryParams(standardDescriptor);
        $timeout(function () {
          $state.go('classroom', {standards: $state.params.standards, viewType: 'grouping'});
        });
      });
    };

    $scope.onStudentNameSelected = function(student) {
      var storageContext = JSON.parse(window.localStorage.getItem('context'));
      if (storageContext) {
        storageContext.student = {
          id: student.id,
          firstName: student.firstName,
          lastName: student.lastName,
          name: student.name,
        };
        window.localStorage.setItem('assignmentContext', JSON.stringify(storageContext));
      }
      navigation.goToItem(student, {pane: 'standards'}, {keepStandards: true});
    };

    $scope.onStudentStandardSelected = function(student, standardIndex) {
      var standard = student.standards[standardIndex];
      var domain = standard.domain;
      $standard.resetQueryParams({
        grade: $scope.gridData.grade.id,
        domain: domain.code,
        standard: standard.code
      });
      $timeout(function() {
        navigation.goToItem(student, {standards: $state.params.standards});
      });
    };

    var selectColumn = function(columnIndex) {
      if ($scope.sort.activeColumnIndex !== columnIndex) {
        $scope.sort.activeColumnIndex = columnIndex;
        $scope.sort.order = 'asc';
      } else {
        $scope.sort.order = $scope.sort.order === 'asc' ? 'desc' : 'asc';
      }
    };

    var sortByStudentsName = function() {
      var students = $scope.gridData.students;
      selectColumn(-1);

      $scope.gridData.students = $filter('orderBy')(students, "name", $scope.sort.order !== 'asc');
    };

    var getStatusOrdinal = function(status) {
      switch (status) {
        case 'NOT_STARTED':
          return 1;
        case 'NEEDS_ATTENTION':
          return 2;
        case 'IN_PROGRESS':
          return 3;
        case 'PROFICIENT':
          return 4;
        default:
          return 0;
      }
    };

    var sortByStandard = function(standardIndex) {
      var students = $scope.gridData.students;
      selectColumn(standardIndex);

      $scope.gridData.students = $filter('orderBy')(students, [
        function(student) {
          var result = getStatusOrdinal(student.standards[standardIndex].proficiency_status);
          return $scope.sort.order === 'asc' ? result : -result;
        },
        function(student) {
          var percentComplete = student.standards[standardIndex].percent_complete;
          return $scope.sort.order === 'asc' ? percentComplete : -percentComplete;
        }, 'name']);
    };

    $scope.onAssignLessonClick = function(standard) {
      var updatedState = {
        domain: standard.domain.code,
        standard: standard.code
      };
      $standard.updateQueryParams(updatedState);

      $timeout(function () {
        $assignMode.onClickAssignMode();
      });
    };
  }])
  .directive('standardsGridTable', function() {
    return {
      restrict: 'E',
      scope: {
        gridData: '='
      },
      templateUrl: '/resources/charts/partials/standards/standards-grid-table.html',
      controller: 'StandardsGridTableController'
    };
  });
